import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/phone_confirmation';
import {PhoneConfirmation} from '../../../reducers/modals/actions';

import Unconfirmed from './unconfirmed';
import Confirmation from './confirmation';

export default () => {
    const {stage, data, user} = useSelector(Selector),
          dispatch = useDispatch();
    
    useEffect(() => {
        if(stage !== user.email.status)
            dispatch(PhoneConfirmation.stage(user.phone.status));
    }, [stage]);

    console.log(user);

    return (
        <div className="modal auth animate__animated animate__fadeInUp animate__faster" style={{zIndex: 15000}}>
            {stage === 'unconfirmed' && <Unconfirmed data={data} user={user} />}
            {stage === 'confirmation' && <Confirmation data={data} user={user} />}
        </div>
    )
}